module.exports = __webpack_public_path__ + "img/doc_ico.387f3dc8.svg";